import React from 'react';
import {
  Button,
  ButtonElevation,
  ButtonIcon,
  ButtonSize,
  ButtonText,
  ButtonType,
} from '@prisjakt/ui/button';
import { Behavior } from '@prisjakt/ui/text';
import { useAppContext } from 'src/components/app-context';
import type { IVariantSelectionButton } from '../types';
import { getColorTranslation, getColor } from './utils/colors';
import { StyledColorDot, VariantGridCell } from './styles';

export const ColorVariantSelectionButton: React.FC<
  IVariantSelectionButton
> = props => {
  const { variant, title, selection, disabled, handleSelection, isMobile } =
    props;
  const { t } = useAppContext();
  const colorVal = getColor(variant);
  const buttonText = title ?? getColorTranslation(t, variant);
  const isSelected = Boolean(
    (variant && selection?.includes(variant)) || (!variant && !selection)
  );

  const onSelect = () => handleSelection(variant);

  return (
    <VariantGridCell $order={colorVal.order}>
      <Button
        onClick={onSelect}
        selectable
        selected={isSelected}
        fullWidth
        type={ButtonType.OUTLINED}
        elevation={ButtonElevation.NONE}
        disabled={disabled}
        size={isMobile ? ButtonSize.NORMAL : ButtonSize.SMALL}
      >
        <>
          {colorVal.hex && (
            <ButtonIcon>
              <StyledColorDot $hex={colorVal.hex as string} />
            </ButtonIcon>
          )}
          <ButtonText behavior={Behavior.OnelineEllipsis}>
            {buttonText}
          </ButtonText>
        </>
      </Button>
    </VariantGridCell>
  );
};
